import React, {
  useState,
  useEffect,
  useCallback,
  useContext,
  useMemo,
} from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "./PageWrapper";
import axiosInstance from "../axiosInstance";
import { TrendingUpIcon, UserIcon, DollarSignIcon } from "../common/Icons";
import { LanguageContext } from "../contexts/LanguageContext";

// Translations object for multiple languages, with Amharic as the source
const translations = {
  am: {
    leaderboard: "የመሪዎች ሰሌዳ",
    loadingLeaderboard: "የመሪዎች ሰሌዳ በመጫን ላይ...",
    noLeaderboardData: "እስካሁን የመሪዎች ሰሌዳ ውሂብ የለም።",
    sessionExpired: "የእርስዎ ክፍለ ጊዜ አልቋል ወይም ልክ ያልሆነ ነው። ወደ መግቢያ መዞር ላይ...",
    networkError: "የአውታረ መረብ ወይም አገልጋይ ስህተት።",
    failedToFetchLeaderboard: "የመሪዎች ሰሌዳ ውሂብ ማግኘት አልተሳካም።",
    error: "ስህተት",
    goToLogin: "ወደ መግቢያ ይሂዱ",
    rank: "ደረጃ",
    totalPlayers: "በመሪዎች ሰሌዳ ላይ ያሉ አጠቃላይ ተጫዋቾች",
    cumulativeWinnings: "በመሪዎች ሰሌዳ ላይ የተከማቸ ድል",
    birr: "ብር",
    bonusFeatureComingSoon: "አስደሳች የቦነስ እድሎች በቅርቡ ይመጣሉ እርሶን እየጠበቁ ነው!",
    leaderboardCalculatedDaily:
      "የመሪዎች ሰሌዳ ከ{startDate} እስከ {endDate} በየቀኑ ይሰላል",
    userNamePhone: "ተጫዋች",
    gamesPlayed: "የተጫወቱት ጨዋታዎች",
    bonus: "ቦነስ",
    points: "ነጥብ",
    notApplicable: "የለም",
    prizeGroup1: "100 ብር ውርርድ",
    prizeGroup2: "10 ብር ውርርድ",
    prizeRank1: "ደረጃ 1: {amount} ብር",
    prizeRank2: "ደረጃ 2: {amount} ብር",
    prizeRank3: "ደረጃ 3: {amount} ብር",
    yourRank: "የእርስዎ ደረጃ",
    you: "እርስዎ",
    stakes: "ውርርድ",
    howToWinBonus: "ቦነስ እንዴት ማሸነፍ ይቻላል",
    pointsToCount:
      "1 ነጥብ እንዲቆጠርልዎ ቢያንስ {requiredPlayers} ተጫዋቾች ባሉበት ጨዋታ መሳተፍ አለብዎት።",
    rulesFor100Birr: "ቦነስ ተሸላሚ እንዲሆኑ በትንሹ 60 ጨዋታዎችን መጫወት አለበዎት",
    rulesFor10Birr: "ቦነስ ተሸላሚ እንዲሆኑ በትንሹ 150 ጨዋታዎችን መጫወት አለበዎት",
    rulescommon: "ቦነስ የሚሸለሙት ከ 1-3 የወጡት ተሳታፊዎች ብቻ ናቸው።",
  },
  en: {
    leaderboard: "Leaderboard",
    loadingLeaderboard: "Loading leaderboard...",
    noLeaderboardData: "No leaderboard data available yet.",
    sessionExpired:
      "Your session has expired or is invalid. Redirecting to login...",
    networkError: "Network or server error.",
    failedToFetchLeaderboard: "Failed to fetch leaderboard data.",
    error: "Error",
    goToLogin: "Go to Login",
    rank: "Rank",
    totalPlayers: "Total Players on Leaderboard",
    cumulativeWinnings: "Cumulative Winnings on Leaderboard",
    birr: "Birr",
    bonusFeatureComingSoon: "Exciting Bonus Features Coming Soon!",
    leaderboardCalculatedDaily:
      "Leaderboard calculated daily from {startDate} to {endDate}",
    userNamePhone: "Players",
    gamesPlayed: "Games Played",
    bonus: "Bonus",
    points: "Points",
    notApplicable: "N/A",
    prizeGroup1: "100 Birr Stakes",
    prizeGroup2: "10 Birr Stakes",
    prizeRank1: "Rank 1: {amount} Birr",
    prizeRank2: "Rank 2: {amount} Birr",
    prizeRank3: "Rank 3: {amount} Birr",
    yourRank: "Your Rank",
    you: "You",
    stakes: "Stakes",
    howToWinBonus: "How to Win the Bonus",
    pointsToCount:
      "To count 1 point, you must have participated in a game with at least {requiredPlayers} players.",
    rulesFor100Birr: "To win bonus: you must play a minimum of 60 games.",
    rulesFor10Birr: "To win bonus: you must play a minimum of 150 games.",
    rulescommon:
      "The bonus is awarded only to participants who finish from 1st to 3rd place.",
  },
  or: {
    leaderboard: "Leedarbordii",
    loadingLeaderboard: "Leedarbordii fe'amaa jira...",
    noLeaderboardData: "Ammas odeeffannoon leedarbordii hin jiru.",
    sessionExpired:
      "Sesshiniin keessan xumureera ykn hin hojjetu. Gara seensaatti deebi'aa...",
    networkError: "Dogoggora networkii ykn serverii.",
    failedToFetchLeaderboard: "Odeeffannoo leedarbordii argachuu hindandeenye.",
    error: "Dogoggora",
    goToLogin: "Gara seensaatti deebi'i",
    rank: "Sadarkaa",
    totalPlayers: "Walumaagalatti Taphataa Leedarbordii Irratti Argaman",
    cumulativeWinnings: "Injifannoo Waliigalaa Leedarbordii Irratti Argaman",
    birr: "Birr",
    bonusFeatureComingSoon: "Amaloota Boonesii Hawwatoo Dhihoo Dhufu!",
    leaderboardCalculatedDaily:
      "Leedarbordiin guyyaa guyyaan {startDate} irraa kaasee hanga {endDate} shallagama",
    userNamePhone: "Maqaa Fayyadamaa",
    gamesPlayed: "Taphataa Taphatame",
    bonus: "Boonesii",
    points: "Qabxii",
    notApplicable: "Hin jiru",
    prizeGroup1: "100 Birr Stakes",
    prizeGroup2: "10 Birr Stakes",
    prizeRank1: "Sadarkaa 1: {amount} Birr",
    prizeRank2: "Sadarkaa 2: {amount} Birr",
    prizeRank3: "Sadarkaa 3: {amount} Birr",
    yourRank: "Sadarkaa Keessan",
    you: "Isin",
    stakes: "Stakes",
    howToWinBonus: "Boonesii Akkamitti Injifachuun Danda'ama",
    pointsToCount:
      "Qabxii 1 lakkaa'uuf, tapha keessatti ቢያንስ {requiredPlayers} taphattoota waliin taphachuu qabda",
    rulesFor100Birr:
      "Boonesii injifachuuf: tapha 60 ol hin taane taphachuu qabda.",
    rulesFor10Birr:
      "Boonesii injifachuuf: tapha 150 ol hin taane taphachuu qabda.",
    rulescommon:
      "The bonus is awarded only to participants who finish from 1st to 3rd place.",
  },
  ti: {
    leaderboard: "ሊደርቦርድ",
    loadingLeaderboard: "ሊደርቦርድ ጽዕን ኣሎ...",
    noLeaderboardData: "እስካሁን ምንም የሊደርቦርድ መረጃ የለም።",
    sessionExpired: "ናይ'ዚ ስራሕ ግዜኹም ወዲኡ ወይ ድማ ቅኑዕ ኣይኮነን። ናብ ምእታው ይምለስሎ...",
    networkError: "ጌጋ መርበብ ወይ ሰርቨር።",
    failedToFetchLeaderboard: "ናይ ሊደርቦርድ መረጃ ምጻእ ኣይከኣለን።",
    error: "ጌጋ",
    goToLogin: "ናብ ምእታው ይኸይድ",
    rank: "ደረጃ",
    totalPlayers: "ብሊደርቦርድ ዘሎ ጠቕላላ ተጻወትቲ",
    cumulativeWinnings: "ብሊደርቦርድ ዝተኣከበ ጠቕላላ ዓወት",
    birr: "ብር",
    bonusFeatureComingSoon: "ዜናዊ ናይ ቦነስ እድሎች ቀሪቡ ይመጽእ ኣሎ!",
    leaderboardCalculatedDaily:
      "ሊደርቦርድ ኩሉ ግዜ ካብ {startDate} ክሳብ {endDate} ይስራሕ",
    userNamePhone: "ሽም ተጠቃሚ",
    gamesPlayed: "ዝተጻወቱ ጸወታታት",
    bonus: "ቦነስ",
    points: "ነጥቢ",
    notApplicable: "የልቦን",
    prizeGroup1: "100 ብር ውርርድ",
    prizeGroup2: "10 ብር ውርርድ",
    prizeRank1: "ደረጃ 1: {amount} ብር",
    prizeRank2: "ደረጃ 2: {amount} ብር",
    prizeRank3: "ደረጃ 3: {amount} ብር",
    yourRank: "ደረጃኹም",
    you: "ንስኹም",
    stakes: "ውርርድ",
    howToWinBonus: "ቦነስ ከመይ ጌርካ ከተዕውት ትኽእል",
    pointsToCount:
      "1 ነጥቢ ንምቑጻር፣ ቢያንስ {requiredPlayers} ተጻወትቲ ኣብ ዝተሳተፉሉ ጸወታ ክትሳተፍ ኣለካ።",
    rulesFor100Birr: "ቦነስ ንምዕዋት: ቢያንስ 60 ጸወታታት ክትጻወት ኣለካ።",
    rulesFor10Birr: "ቦነስ ንምዕዋት: ቢያንስ 150 ጸወታታት ክትጻወት ኣለካ።",
    rulescommon: "ቦነስ ዝወሃበካ ካብ 1-3 ዝወጹ ተሳተፍቲ ጥራሕ እዩ።",
  },
  wo: {
    leaderboard: "Leedarbordii",
    loadingLeaderboard: "Leedarbordii fe'amaa jira...",
    noLeaderboardData: "Ammas odeeffannoon leedarbordii hin jiru.",
    sessionExpired:
      "Sesshiniin keessan xumureera ykn hin hojjetu. Gara seensaatti deebi'aa...",
    networkError: "Dogoggora networkii ykn serverii.",
    failedToFetchLeaderboard: "Odeeffannoo leedarbordii argachuu hindandeenye.",
    error: "Dogoggora",
    goToLogin: "Gara seensaatti deebi'i",
    rank: "Sadarkaa",
    totalPlayers: "Walumaagalatti Taphataa Leedarbordii Irratti Argaman",
    cumulativeWinnings: "Injifannoo Waliigalaa Leedarbordii Irratti Argaman",
    birr: "Birr",
    bonusFeatureComingSoon: "Amaloota Boonesii Hawwatoo Dhihoo Dhufu!",
    leaderboardCalculatedDaily:
      "Leedarbordiin guyyaa guyyaan {startDate} irraa kaasee hanga {endDate} shallagama",
    userNamePhone: "Maqaa Fayyadamaa",
    gamesPlayed: "Taphataa Taphatame",
    bonus: "Boonesii",
    points: "Qabxii",
    notApplicable: "Hin jiru",
    prizeGroup1: "100 Birr Stakes",
    prizeGroup2: "10 Birr Stakes",
    prizeRank1: "Sadarkaa 1: {amount} Birr",
    prizeRank2: "Sadarkaa 2: {amount} Birr",
    prizeRank3: "Sadarkaa 3: {amount} Birr",
    yourRank: "Sadarkaa Keessan",
    you: "Isin",
    stakes: "Stakes",
    howToWinBonus: "Boonesii Akkamitti Injifachuun Danda'ama",
    pointsToCount:
      "Qabxii 1 lakkaa'uuf, tapha keessatti ቢያንስ {requiredPlayers} taphattoota waliin taphachuu qabda",
    rulesFor100Birr:
      "Boonesii injifachuuf: tapha 60 ol hin taane taphachuu qabda.",
    rulesFor10Birr:
      "Boonesii injifachuuf: tapha 150 ol hin taane taphachuu qabda.",
    rulescommon:
      "The bonus is awarded only to participants who finish from 1st to 3rd place.",
  },
};

const LeaderboardPage = ({ setCurrentPage, ...props }) => {
  const { language } = useContext(LanguageContext);
  const navigate = useNavigate();
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true); // New state to handle initial load vs refresh
  const [error, setError] = useState("");
  const [selectedStake, setSelectedStake] = useState(10);
  const [leaderboardDateRange, setLeaderboardDateRange] = useState({
    am: null,
    en: null,
  });
  const [currentUserRank, setCurrentUserRank] = useState(null);

  const t = useCallback(
    (key, variables = {}) => {
      let translation =
        translations[language]?.[key] || translations.am[key] || key;
      for (const [placeholder, value] of Object.entries(variables)) {
        translation = translation.replace(`{${placeholder}}`, value);
      }
      return translation;
    },
    [language]
  );

  // Helper function to get the current leaderboard date range for display
  const getLeaderboardDateRange = useCallback(() => {
    const now = new Date();
    const currentHour = now.getHours();

    let startDate = new Date();
    let endDate = new Date();

    // The leaderboard starts at 12 PM (6 PM Ethiopian time)
    // and ends at 12 PM the next day.
    if (currentHour < 12) {
      startDate.setDate(now.getDate() - 1);
    }
    startDate.setHours(12, 0, 0, 0);
    endDate.setDate(startDate.getDate() + 1);
    endDate.setHours(3, 0, 0, 0);

    // Amharic (Ethiopian Calendar) date and time format
    const ethiopianDateFormatter = new Intl.DateTimeFormat(
      "am-ET-u-ca-ethiopic",
      {
        year: "numeric",
        month: "long",
        day: "numeric",
      }
    );

    // Get date parts and reorder for Amharic
    const ethiopianDateParts = ethiopianDateFormatter.formatToParts(startDate);
    const dayPart = ethiopianDateParts.find(
      (part) => part.type === "day"
    ).value;
    const monthPart = ethiopianDateParts.find(
      (part) => part.type === "month"
    ).value;
    const yearPart = ethiopianDateParts.find(
      (part) => part.type === "year"
    ).value;

    const ethiopianStartDate = `${monthPart} ${dayPart}, ${yearPart} ዓ.ም`;

    const ethiopianEndDateParts = ethiopianDateFormatter.formatToParts(endDate);
    const endDayPart = ethiopianEndDateParts.find(
      (part) => part.type === "day"
    ).value;
    const endMonthPart = ethiopianEndDateParts.find(
      (part) => part.type === "month"
    ).value;
    const endYearPart = ethiopianEndDateParts.find(
      (part) => part.type === "year"
    ).value;

    const ethiopianEndDate = `${endMonthPart} ${endDayPart} ${endYearPart} ዓ.ም`;

    // English (Gregorian Calendar) date and time format
    const englishDateFormatter = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    const englishTimeFormatter = new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    const englishStartDate = `${englishDateFormatter.format(
      startDate
    )} G.C. ${englishTimeFormatter.format(startDate)}`;
    const englishEndDate = `${englishDateFormatter.format(
      endDate
    )} G.C. ${englishTimeFormatter.format(endDate)}`;

    // Amharic time string, for simplicity and cultural context, 12:00PM is 6:00 PM Ethiopian time
    const amharicTime = " ከቀኑ 6:00 ሰዓት"; // Adjusted to 6 PM Ethiopian Time

    // Combine the reordered date with the time
    const finalAmharicStartDate = `${ethiopianStartDate}${amharicTime}`;
    const finalAmharicEndDate = `${ethiopianEndDate}${amharicTime}`;

    return {
      am: { startDate: finalAmharicStartDate, endDate: finalAmharicEndDate },
      en: { startDate: englishStartDate, endDate: englishEndDate },
    };
  }, []);

  const fetchLeaderboard = useCallback(async () => {
    try {
      if (isInitialLoad) {
        setIsInitialLoad(true); // Keep loading state for the first time
      }
      const response = await axiosInstance.get("/user/leaderboard");
      if (response.data.success) {
        setLeaderboardData(response.data.leaderboard);
        setCurrentUserRank(response.data.currentUserRank);
        setError("");
      } else {
        setError(response.data.message || t("failedToFetchLeaderboard"));
      }
    } catch (err) {
      console.error("Error fetching leaderboard:", err);
      if (err.response?.status === 401 || err.response?.status === 403) {
        setError(t("sessionExpired"));
        localStorage.removeItem("token");
        navigate("/login");
      } else {
        setError(err.response?.data?.message || t("networkError"));
      }
    } finally {
      setIsInitialLoad(false); // Set to false after first load completes
    }
  }, [navigate, t, isInitialLoad]);

  useEffect(() => {
    setCurrentPage(t("leaderboard"));
    fetchLeaderboard();
    setLeaderboardDateRange(getLeaderboardDateRange());

    const dataRefreshInterval = setInterval(() => {
      setLeaderboardDateRange(getLeaderboardDateRange());
      fetchLeaderboard();
    }, 30000);

    return () => clearInterval(dataRefreshInterval);
  }, [setCurrentPage, fetchLeaderboard, t, getLeaderboardDateRange]);

  const displayedLeaderboard = useMemo(() => {
    if (!leaderboardData.length) return [];

    // Filter by selected stake
    const filteredByStake = leaderboardData.filter(player =>
      selectedStake === 100
        ? player.stakeAmount >= 100
        : player.stakeAmount < 100
    );

    // Sort by gamesPlayed (descending) and then by rank
    const sortedPlayers = [...filteredByStake].sort((a, b) => {
      if (b.gamesPlayed !== a.gamesPlayed) {
        return b.gamesPlayed - a.gamesPlayed;
      }
      return a.rank - b.rank;
    });

    // Assign displayRank
    const rankedFilteredPlayers = sortedPlayers.map((player, index) => ({
      ...player,
      displayRank: index + 1
    }));

    // Identify current user
    const currentUserEntry = rankedFilteredPlayers.find(p => p.isCurrentUser);

    // Create final list (top 10 + current user if not in top 10)
    let finalTableData = rankedFilteredPlayers.slice(0, 10);
    
    if (currentUserEntry && currentUserEntry.displayRank > 10) {
      const isCurrentUserAlreadyInTop10 = finalTableData.some(p => p.id === currentUserEntry.id);
      if (!isCurrentUserAlreadyInTop10) {
        finalTableData.push(currentUserEntry);
      }
    }

    // Apply bonus values and strikethrough logic based on rules
    return finalTableData.map(player => {
      let bonusToDisplay = t("notApplicable");
      let hasStrikethrough = false;
      
      // Check if player is in the top 3
      if (player.displayRank >= 1 && player.displayRank <= 3) {
        if (selectedStake === 10) {
          const requiredGames = 150;
          if (player.gamesPlayed >= requiredGames) {
            if (player.displayRank === 1) bonusToDisplay = "1,500";
            else if (player.displayRank === 2) bonusToDisplay = "1,000";
            else if (player.displayRank === 3) bonusToDisplay = "500";
          } else {
            hasStrikethrough = true;
            if (player.displayRank === 1) bonusToDisplay = "1,500";
            else if (player.displayRank === 2) bonusToDisplay = "1,000";
            else if (player.displayRank === 3) bonusToDisplay = "500";
          }
        } else if (selectedStake === 100) {
          const requiredGames = 60;
          if (player.gamesPlayed >= requiredGames) {
            if (player.displayRank === 1) bonusToDisplay = "5,000";
            else if (player.displayRank === 2) bonusToDisplay = "2,500";
            else if (player.displayRank === 3) bonusToDisplay = "1,500";
          } else {
            hasStrikethrough = true;
            if (player.displayRank === 1) bonusToDisplay = "5,000";
            else if (player.displayRank === 2) bonusToDisplay = "2,500";
            else if (player.displayRank === 3) bonusToDisplay = "1,500";
          }
        }
      }
      return { ...player, bonusToDisplay, hasStrikethrough };
    });
  }, [leaderboardData, selectedStake, t]);

  // Display loading state only on initial page load, or if no data is present
  if (isInitialLoad) {
    return (
      <PageWrapper {...props}>
        <div className="flex justify-center items-center h-screen bg-gradient-to-br from-indigo-900 to-purple-800">
          <p className="text-gray-200 text-lg">{t("loadingLeaderboard")}</p>
        </div>
      </PageWrapper>
    );
  }

  // Display error state
  if (error) {
    return (
      <PageWrapper {...props}>
        <div className="flex flex-col justify-center items-center h-screen text-red-400 bg-gradient-to-br from-indigo-900 to-purple-800">
          <p className="text-lg mb-4">
            {t("error")}: {error}
          </p>
          <button
            onClick={() => navigate("/login")}
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-md shadow-lg transition duration-300 ease-in-out"
          >
            {t("goToLogin")}
          </button>
        </div>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper {...props}>
      <div className="bg-gradient-to-br from-purple-900 to-indigo-950 text-white min-h-screen max-w-4xl mx-auto py-8 px-3 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-center mb-8 flex items-center justify-center space-x-3 text-yellow-400">
          <TrendingUpIcon className="w-8 h-8 text-yellow-400" />
          <span>{t("leaderboard")}</span>
          <TrendingUpIcon className="w-8 h-8 text-yellow-400 transform scale-x-[-1]" />
        </h1>

        <div className="bg-red-600 text-white text-center py-2 px-4 rounded-lg mb-6 font-semibold shadow-md">
          {t("bonusFeatureComingSoon")}
        </div>

        <div className="flex justify-center space-x-4 mb-4">
          <button
            onClick={() => setSelectedStake(10)}
            className={`py-3 px-6 rounded-lg shadow-lg transition duration-300 ease-in-out font-semibold
                ${selectedStake === 10 ? 'bg-blue-600 text-white' : 'bg-gray-600 hover:bg-gray-700 text-white'}`}
          >
            10 {t("birr")} {t("stakes")}
          </button>
          <button
            onClick={() => setSelectedStake(100)}
            className={`py-3 px-6 rounded-lg shadow-lg transition duration-300 ease-in-out font-semibold
                ${selectedStake === 100 ? 'bg-blue-600 text-white' : 'bg-gray-600 hover:bg-gray-700 text-white'}`}
          >
            100 {t("birr")} {t("stakes")}
          </button>
        </div>

        {/* Current User Rank Display */}
        {currentUserRank && (
          <div className="text-center mb-4">
            <p className="text-lg text-emerald-400">
              {t("yourRank")}: {currentUserRank}
            </p>
          </div>
        )}

        <div className="text-center text-gray-300 mb-8 space-y-3 bg-white bg-opacity-10 rounded-xl p-4 shadow-lg">
          <h2 className="text-lg font-bold text-yellow-400 mb-2">{t("howToWinBonus")}</h2>
          <p className="text-white text-sm">{t("rulescommon")}</p>
          {selectedStake === 10 ? (
            <p className="text-white text-sm">{t("rulesFor10Birr")}</p>
          ) : (
            <p className="text-white text-sm">{t("rulesFor100Birr")}</p>
          )}
        </div>

        {leaderboardDateRange.am && leaderboardDateRange.en && (
          <p className="text-center text-gray-300 mb-8 text-sm">
            {t("leaderboardCalculatedDaily", {
              startDate: language === 'am' ? leaderboardDateRange.am.startDate : leaderboardDateRange.en.startDate,
              endDate: language === 'am' ? leaderboardDateRange.am.endDate : leaderboardDateRange.en.endDate
            })}
          </p>
        )}

        <div className="bg-white bg-opacity-10 rounded-xl p-6 shadow-xl">
          {displayedLeaderboard.length === 0 ? (
            <p className="text-gray-300 text-center">
              {t("noLeaderboardData")}
            </p>
          ) : (
            <table className="min-w-full divide-y divide-gray-700">
              <thead className="bg-gray-700 bg-opacity-50">
                <tr>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                    {t("rank")}
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                    {t("userNamePhone")}
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                    {t("points")}
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                    {t("bonus")}
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-800">
                {displayedLeaderboard.map((player) => (
                  <tr
                    key={player.id}
                    className={`
                        hover:bg-gray-700 hover:bg-opacity-20 transition duration-150 ease-in-out 
                        ${player.isCurrentUser ? 'bg-emerald-400 bg-opacity-30' : ''}
                        ${player.displayRank > 10 ? 'border-t-2 border-gray-600' : ''}
                    `}
                  >
                    <td className="px-3 py-2 text-sm font-medium text-gray-200">
                      {player.displayRank}
                      {player.isCurrentUser && (
                        <span className="ml-1 text-xs text-gray-400">({t("yourRank")})</span>
                      )}
                    </td>

                    <td className="px-3 py-2 text-sm text-gray-200">
                      <span title={`${player.userName} ${player.phoneLastDigits}`}>
                        <UserIcon className="inline w-5 h-5 mr-2 text-blue-300 align-middle" />
                        {player.userName} ({player.phoneLastDigits})
                        {player.isCurrentUser && (
                          <span className="ml-2 bg-emerald-500 text-white text-xs px-2 py-1 rounded-full">
                            {t("you")}
                          </span>
                        )}
                      </span>
                    </td>

                    <td className="px-3 py-2 text-sm text-gray-200">
                      {player.gamesPlayed}
                    </td>

                    <td className="px-3 py-2 text-sm text-gray-200">
                      {player.bonusToDisplay !== t("notApplicable") ? (
                        <span className={player.hasStrikethrough ? 'line-through text-red-300' : ''}>
                          <DollarSignIcon className="inline w-5 h-5 mr-1 text-green-300 align-middle" />
                          {player.bonusToDisplay}
                        </span>
                      ) : (
                        t("notApplicable")
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </PageWrapper>
  );
};

export default LeaderboardPage;
